import Svg from "../Svg";

interface IconProps {
  width: number;
  height: number;
}

const CoveredStadiumIcon = ({ width, height }: IconProps) => (
  <Svg width={width} height={height}>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.23714 1.07468C2.38455 0.983572 2.56861 0.97529 2.72361 1.05279L5.72361 2.55279C5.893 2.63748 6 2.81061 6 3C6 3.18939 5.893 3.36252 5.72361 3.44721L2.72361 4.94721C2.56861 5.02471 2.38455 5.01643 2.23714 4.92533C2.08973 4.83422 2 4.67329 2 4.5V1.5C2 1.32671 2.08973 1.16578 2.23714 1.07468ZM3 2.30902V3.69098L4.38197 3L3 2.30902Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2371 1.07468C12.3845 0.983572 12.5686 0.97529 12.7236 1.05279L15.7236 2.55279C15.893 2.63748 16 2.81061 16 3C16 3.18939 15.893 3.36252 15.7236 3.44721L12.7236 4.94721C12.5686 5.02471 12.3845 5.01643 12.2371 4.92533C12.0897 4.83422 12 4.67329 12 4.5V1.5C12 1.32671 12.0897 1.16578 12.2371 1.07468ZM13 2.30902V3.69098L14.382 3L13 2.30902Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4V6.5H2V4H3Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 4V6H12V4H13Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 16C1.44772 16 1 15.5523 1 15V10C1 9.44772 1.44772 9 2 9H14C14.5523 9 15 9.44772 15 10V15C15 15.5523 14.5523 16 14 16H2ZM2 10H14V15H2V10Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.2513 6.91782C2.36195 5.66833 4.38278 4.5 8 4.5C11.6172 4.5 13.6381 5.66833 14.7487 6.91782C15.2972 7.5349 15.6077 8.15418 15.7814 8.62322C15.8683 8.85779 15.9213 9.05559 15.9529 9.19818C15.9688 9.26953 15.9794 9.32724 15.9862 9.36904C15.9896 9.38995 15.992 9.4069 15.9938 9.41961L15.9958 9.43548L15.9965 9.44096L15.9968 9.44308C15.9968 9.44349 15.9969 9.44479 15.5 9.5L15.9969 9.44479C16.0126 9.58614 15.9674 9.72749 15.8726 9.83346C15.7777 9.93944 15.6422 10 15.5 10H0.500002C0.357781 10 0.222289 9.93944 0.127438 9.83346C0.0325878 9.72749 -0.0126452 9.58614 0.00306056 9.44479L0.500002 9.5C0.00306058 9.44479 0.00301479 9.44519 0.00306056 9.44479L0.00325237 9.44308L0.00349785 9.44096L0.0041589 9.43548L0.0062245 9.41961C0.0079558 9.4069 0.0104292 9.38995 0.0138365 9.36904C0.0206489 9.32724 0.0312096 9.26953 0.0470651 9.19818C0.0787511 9.05559 0.131751 8.85779 0.218628 8.62322C0.392347 8.15418 0.702781 7.5349 1.2513 6.91782ZM0.996624 9.558C0.99657 9.55847 0.996617 9.55806 0.996624 9.558V9.558ZM1.1456 9C1.14911 8.99027 1.1527 8.98045 1.15638 8.97053C1.29516 8.59582 1.54722 8.0901 1.99871 7.58218C2.88805 6.58167 4.61723 5.5 8 5.5C11.3828 5.5 13.112 6.58167 14.0013 7.58218C14.4528 8.0901 14.7048 8.59582 14.8436 8.97053C14.8473 8.98045 14.8509 8.99027 14.8544 9H1.1456Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12.5C6 12.2239 6.22386 12 6.5 12H9.5C9.77614 12 10 12.2239 10 12.5V15.5H9V13H7V15.5H6V12.5Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49148 9.40806C4.49143 9.40779 4.49137 9.40751 4 9.5C3.50863 9.59249 3.50858 9.59219 3.50852 9.59188L3.50811 9.58966L3.50741 9.58583L3.50558 9.57523C3.50417 9.56687 3.50242 9.55593 3.50045 9.54253C3.4965 9.51572 3.49167 9.479 3.48698 9.43324C3.47761 9.34178 3.46875 9.21373 3.46875 9.05615C3.46875 8.74145 3.50409 8.3055 3.64346 7.80683C3.92532 6.79829 4.62453 5.56576 6.2382 4.57402L6.7618 5.42598C5.37548 6.278 4.82469 7.29547 4.60655 8.07599C4.49592 8.47185 4.46875 8.81519 4.46875 9.05615C4.46875 9.17641 4.47552 9.27029 4.48177 9.33129C4.48489 9.36176 4.48788 9.3839 4.48979 9.39691L4.49174 9.40942L4.49148 9.40806Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5085 9.40806C11.5086 9.40779 11.5086 9.40751 12 9.5C12.4914 9.59249 12.4914 9.59219 12.4915 9.59188L12.4919 9.58966L12.4926 9.58583L12.4944 9.57523C12.4958 9.56687 12.4976 9.55593 12.4996 9.54253C12.5035 9.51572 12.5083 9.479 12.513 9.43324C12.5224 9.34178 12.5313 9.21373 12.5313 9.05615C12.5313 8.74145 12.4959 8.3055 12.3566 7.80683C12.0747 6.79829 11.3755 5.56576 9.7618 4.57402L9.2382 5.42598C10.6245 6.278 11.1753 7.29547 11.3935 8.07599C11.5041 8.47185 11.5313 8.81519 11.5313 9.05615C11.5313 9.17641 11.5245 9.27029 11.5182 9.33129C11.5151 9.36176 11.5121 9.3839 11.5102 9.39691L11.5083 9.40942L11.5085 9.40806Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 5V9.5H7.5V5H8.5Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10V15.5H4V10H5Z"
        fill="#6A6F73"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10V15.5H11V10H12Z"
        fill="#6A6F73"
      />
    </svg>
  </Svg>
);

export default CoveredStadiumIcon;
